<template>
<div class="col-12 col-md-3">
  <div class="card shadow-sm rounded rounded-3">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <div class="">
            <img :src="require('../assets/images/'+ icon)" class="card-img" alt="">
          </div>
        </div>
        <div class="col">
          <h4 class="fw-bold" style="color: #3a23bc;">{{ title }}</h4>
          <p class="fw-bold mb-0" style="color: #b857cb;">{{ subTitle }}</p>
          <h5 class="mt-2 fw-bold text-black">{{ count }}
            <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i></h5>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Card",
  data() {
    return {
      // imgg: require('../assets/images/gift-dynamic-gradient.png')
    }
  },
  // default: require('../assets/images/gift-dynamic-gradient.png'),
  props: {
    icon:{
      type:String,
      default: 'gift-dynamic-gradient.png',
    },
    title: String,
    subTitle : String,
    count:String,
  },
}
</script>

<style scoped>
.card{
  height: 140px !important;
  transition: .5s;
}
.card:hover{
  transform: translateY(-2px);
  box-shadow: 1px 2px 3px #7386D5 !important;
}
</style>